import { render } from "./DepartmentOverview.vue?vue&type=template&id=d3d8bbc4&scoped=true"
import script from "./DepartmentOverview.vue?vue&type=script&lang=js"
export * from "./DepartmentOverview.vue?vue&type=script&lang=js"

import "./DepartmentOverview.vue?vue&type=style&index=0&id=d3d8bbc4&scoped=true&lang=css"

import exportComponent from "/Applications/PROJECTS/HMS-MAIN/PORTAL/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d3d8bbc4"]])

export default __exports__